export default "__VITE_ASSET__DbY1kRm1__"